module.exports = __webpack_public_path__ + "img/sweet-spot-header.53ea3064.png";